var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCopyHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3719 14.2942C10.8572 14.2942 11.2726 14.1214 11.6182 13.7758C11.9638 13.4302 12.1366 13.0147 12.1366 12.5295V1.94122C12.1366 1.45593 11.9638 1.04048 11.6182 0.694896C11.2726 0.349308 10.8572 0.176514 10.3719 0.176514H2.43072C1.94543 0.176514 1.52999 0.349308 1.1844 0.694896C0.838809 1.04048 0.666016 1.45593 0.666016 1.94122V12.5295C0.666016 13.0147 0.838809 13.4302 1.1844 13.7758C1.52999 14.1214 1.94543 14.2942 2.43072 14.2942H10.3719ZM10.3719 12.5295H2.43072V1.94122H10.3719V12.5295ZM13.9013 17.8236C14.3866 17.8236 14.802 17.6508 15.1476 17.3052C15.4932 16.9596 15.666 16.5442 15.666 16.0589V3.70593H13.9013V16.0589H4.19543V17.8236H13.9013Z",
    fill: "#AD46FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopyHover);
export default __webpack_public_path__ + "static/media/content_copy_hover.f0e6f76b583a9b728a83ebd2b767c815.svg";
export { ForwardRef as ReactComponent };